import {Block, Divider} from '@travel-frontend/ui-components';
import {Children} from 'react';
import {Virtuoso} from 'react-virtuoso';

export const MenuList = (props: any) => {
  const {children, options, getStyles} = props;
  const items = Children.toArray(children);
  const renderItem = (index: number) => (
    <>
      {index > 0 && options[index].label.type === 'groupHeader' ? (
        <Block as={Divider} margin={[0, '16px']} />
      ) : null}
      {items[index]}
      {options[index].label.type === 'reset' && options.length > 1 ? (
        <Block as={Divider} margin={[0, '16px']} />
      ) : null}
    </>
  );

  return (
    <Virtuoso
      style={{
        ...getStyles('menuList', props),
        height: Math.min(400, 38 * items.length),
      }}
      data={items}
      totalCount={items.length}
      itemContent={renderItem}
    />
  );
};
